import { Typography, withStyles } from "@material-ui/core";
import React from "react";
import Button from "../../shared/button";
import Title from "../../shared/title";
import { t, Trans } from "adapters/i18n";

const GoalPlanRevisionHeader = ({
  classes,
  goalPlanRevisionList,
  handleShowOriginalPlan,
}) => {
  const revisionName =
    goalPlanRevisionList && goalPlanRevisionList.length > 0
      ? goalPlanRevisionList[0].name
      : "";

  return (
    <div className="goal-plan-revision-header">
      <div className={classes.header}>
        <Typography className={classes.title}>
          <Trans
            i18nKey="goalPlan:visualizing-plan-revisions"
            values={{ revisionName }}
            components={{ b: <b /> }}
          />
        </Typography>
        <Button
          data-testid="button"
          label={t("goalPlan:see-original")}
          onClick={() => handleShowOriginalPlan(goalPlanRevisionList.id)}
        />
      </div>
      <Title>{t("goalPlan:revisions")}:</Title>
    </div>
  );
};

const styles = {
  header: {
    marginTop: "40px",
    marginBottom: "40px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: "20px",
    color: "#333333",
  },
};

export default withStyles(styles)(GoalPlanRevisionHeader);
